/**
 * ページフロー制御ユーティリティ
 */

/** プランボタン押下時のリダイレクト先URL */
export function getPlanButtonUrl(isSignedIn: boolean): string {
	if (isSignedIn) return "/mypage";
	return `/sign-in?redirect_url=${encodeURIComponent("/mypage")}`;
}
